import _ from 'lodash';
import { useRouter } from 'next/router';
import React from 'react';
import gsap from 'gsap';
import MaxWidthContainer from 'components/MaxWidthContainer';
// import classnames from 'classnames';
// import Link from 'next/link';
// import { useGSAP } from '@gsap/react';
// import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
// import lottie from 'lottie-web';

// import { useUserAuth } from 'contexts/UserAuth';
// import redirectToLogin from 'utils/redirectToLogin';
// import { useWindowSize } from 'react-use';

// import api from 'utils/api';

import AnimateTargetNumber from 'components/AnimateTargetNumber';
// import useRWD from 'hooks/useRWD';
// import Beauty2024Ring from 'components/Beauty2024Ring';
// import Beauty2024RingX15 from 'components/Beauty2024RingX15';
// import Beauty2024Light from 'components/Beauty2024Light';

// gsap.registerPlugin(useGSAP);
// gsap.registerPlugin(ScrollTrigger);

const { useState, useEffect, useRef, forwardRef } = React;

// const [featureFirst, setFeatureFirst] = useState(0);

const CardTitle = ({ n = 0, title = '' }) => {
  return (
    <div className="absolute left-0 right-0 top-0 flex -translate-y-1/2 items-center justify-center gap-x-2">
      <div className="flex items-center gap-x-px font-rubik font-normal text-sorra-pink lg:gap-x-2">
        <p className="text-xl lg:text-[32px]">(</p>
        <p className="w-7 text-center text-xl font-medium lg:text-2xl">Q{n}.</p>
        <p className="text-xl lg:text-[32px]">)</p>
      </div>
      <p className="text-xl font-medium lg:text-2xl">{title}</p>
    </div>
  );
};

const PercentDesc = ({ percent = 0, desc = '' }) => {
  return (
    <div className="text-sorra-pink">
      <p className="text-center text-xl font-semibold lg:text-[34px]">
        {percent}
        <span className="text-[13px] font-bold lg:text-[18px]">%</span>
      </p>
      <p className="mt-0 text-center text-xs font-normal lg:mt-1 lg:text-[18px]">
        {desc}
      </p>
    </div>
  );
};

const BeautyAwards2024Result = (props) => {
  // const { isLg } = useRWD();
  const [featureFirst, setFeatureFirst] = useState(0);
  const router = useRouter();

  useEffect(() => {
    // console.log(document.querySelector('.feature-0'));
    gsap.set('.first-0', {
      x: '0%',
    });
    gsap.set('.first-1', {
      x: '100%',
    });
    gsap.to('.first-0', {
      x: '-100%',
      duration: 20,
      ease: 'linear',
      onComplete: () => {
        gsap.set('.first-0', {
          x: '100%',
        });
        gsap.to('.first-0', {
          x: '-100%',
          duration: 40,
          ease: 'linear',
          repeat: -1,
        });
      },
    });
    gsap.to('.first-1', {
      x: '-100%',
      duration: 40,
      ease: 'linear',
      repeat: -1,
    });

    // -50
    gsap.to('#leftLight', {
      rotate: 0,
      duration: 3,
      ease: 'linear',
      repeat: -1,
      yoyo: true,
      // reversed: true,
      // reversed: true,
    });

    // 50
    gsap.to('#rightLight', {
      rotate: 0,
      duration: 3,
      ease: 'linear',
      repeat: -1,
      yoyo: true,
      // reversed: true,
      // reversed: true,
    });

    return () => {
      gsap.killTweensOf('#leftLight');
      gsap.killTweensOf('#rightLight');
      gsap.killTweensOf('.first-0');
      gsap.killTweensOf('.first-1');
    };
  }, []);

  useEffect(() => {
    let interval = null;
    interval = setInterval(() => {
      setFeatureFirst((prev) => {
        return (prev + 1) % 10;
      });
    }, 3000);
    return () => {
      if (interval) {
        clearInterval(interval);
        interval = null;
      }
    };
  }, []);

  useEffect(() => {
    // const targets = [
    //   `feature-${(featureFirst + 8) % 10}`,
    //   `feature-${(featureFirst + 9) % 10}`,
    //   `feature-${featureFirst}`,
    //   `feature-${(featureFirst + 1) % 10}`,
    //   `feature-${(featureFirst + 2) % 10}`,
    // ];
    gsap.to(`.feature-${(featureFirst + 7) % 10}`, {
      x: '-300%',
      opacity: 0,
      scale: 0.8,
      onComplete: () => {
        gsap.set(`.feature-${(featureFirst + 7) % 10}`, {
          x: '300%',
          y: '-10px',
          scale: 0.8,
          opacity: 0,
          filter: 'blur(0.5px)',
        });
      },
    });
    gsap.to(`.feature-${(featureFirst + 8) % 10}`, {
      x: '-225%',
      y: '-10px',
      scale: 0.9,
      opacity: 1,
      filter: 'blur(2px)',
    });
    gsap.to(`.feature-${(featureFirst + 9) % 10}`, {
      x: '-115%',
      y: '-10px',
      scale: 1,
      opacity: 1,
      filter: 'blur(1px)',
    });
    gsap.to(`.feature-${featureFirst}`, {
      x: '0%',
      y: '10px',
      scale: 1.1,
      opacity: 1,
      filter: 'blur(0px)',
    });
    gsap.to(`.feature-${(featureFirst + 1) % 10}`, {
      x: '115%',
      y: '-10px',
      scale: 1,
      opacity: 1,
      filter: 'blur(1px)',
    });
    gsap.to(`.feature-${(featureFirst + 2) % 10}`, {
      x: '225%',
      y: '-10px',
      scale: 0.9,
      opacity: 1,
      filter: 'blur(2px)',
    });
  }, [featureFirst]);

  return (
    <div
      style={
        {
          // background: 'linear-gradient(180deg, #F16B7C 0%, #FFF 119.76%)',
        }
      }
      className="w-full overflow-hidden"
    >
      <div
        style={{
          background: 'linear-gradient(180deg, #FFC5CA 0%, #E76571 63.5%)',
        }}
        className="relative flex aspect-[397/380] h-auto w-full flex-col items-center lg:aspect-auto lg:h-[700px]"
      >
        <div className="absolute left-1/2 top-0 w-1/2 -translate-x-1/2 -translate-y-1/2">
          <img
            className="w-full object-contain"
            src="/images/2024/result/mobile/spotlight.png"
          />
        </div>
        <div
          id="leftLight"
          className="absolute left-0 top-0 w-1/2 -translate-x-1/2 -translate-y-1/2 -rotate-[50deg]"
        >
          <img
            className="w-full object-contain"
            src="/images/2024/result/mobile/spotlight.png"
          />
        </div>
        <div
          id="rightLight"
          className="absolute right-0 top-0 w-1/2 -translate-y-1/2 translate-x-1/2 rotate-[50deg]"
        >
          <img
            className="w-full object-contain"
            src="/images/2024/result/mobile/spotlight.png"
          />
        </div>

        <div className="relative mt-8 aspect-[128/114] h-[80px] lg:mt-14 lg:h-[114px]">
          <img
            src="/images/2024/voting-result.png"
            className="h-full w-full object-contain"
          />
        </div>
        <div className="aspect-[623/400] h-[187px] lg:h-[400px]">
          <img
            src="/images/2024/voting-result-banner.png"
            className="h-full w-full object-contain"
          />
        </div>

        <div
          className="absolute right-[115px] top-[86px] hidden cursor-pointer items-center gap-x-3 rounded-full bg-sorra-pink px-6 py-3 lg:flex"
          onClick={() => {
            router.push('/');
          }}
        >
          <p className="text-white">前往SORRA主頁 </p>
          <div className="h-3 w-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                d="M0.292893 12.2929C-0.0976311 12.6834 -0.0976311 13.3166 0.292893 13.7071C0.683418 14.0976 1.31658 14.0976 1.70711 13.7071L0.292893 12.2929ZM14 0.999999C14 0.447714 13.5523 -8.61581e-07 13 -1.11446e-06L4 -3.13672e-07C3.44772 -6.50847e-07 3 0.447715 3 0.999999C3 1.55228 3.44772 2 4 2L12 2L12 10C12 10.5523 12.4477 11 13 11C13.5523 11 14 10.5523 14 10L14 0.999999ZM1.70711 13.7071L13.7071 1.70711L12.2929 0.292893L0.292893 12.2929L1.70711 13.7071Z"
                fill="white"
              />
            </svg>
          </div>
        </div>

        <div className="absolute -bottom-[15px] left-0 flex w-full overflow-visible lg:-bottom-[35px]">
          {/* <MaxWidthContainer className="relative flex overflow-visible"> */}
          <div className="first-0 flex">
            {Array(18)
              .fill(0)
              .map((_, i) => {
                return (
                  <div
                    key={i}
                    className="mx-1.5 aspect-[90/130] w-[90px] lg:mx-3 lg:w-[187px]"
                  >
                    <img
                      src={`/images/2024/result/mobile/first_${i % 9}.png`}
                      className="h-full w-full object-contain object-bottom"
                    />
                  </div>
                );
              })}
          </div>
          <div className="first-1 absolute left-0 top-0 flex translate-x-full">
            {Array(18)
              .fill(0)
              .map((_, i) => {
                return (
                  <div
                    key={i}
                    className="mx-1.5 aspect-[90/130] w-[90px] lg:mx-3 lg:w-[187px]"
                  >
                    <img
                      src={`/images/2024/result/mobile/first_${i % 9}.png`}
                      className="h-full w-full object-contain object-bottom"
                    />
                  </div>
                );
              })}
          </div>
          {/* </MaxWidthContainer> */}
        </div>
        {/* <div className="absolute -bottom-[15px] left-0 flex overflow-visible lg:-bottom-[35px]">
          {Array(9)
            .fill(0)
            .map((_, i) => {
              return (
                <div
                  key={i}
                  className="mx-1.5 aspect-[90/130] w-[90px] lg:mx-3 lg:w-[187px]"
                >
                  <img
                    src={`/images/2024/result/mobile/first_${i % 9}.png`}
                    className="h-full w-full object-contain object-bottom"
                  />
                </div>
              );
            })}
        </div> */}
      </div>
      <div
        style={{
          background: 'linear-gradient(180deg, #FFF 0%, #FFE3E5 76.5%)',
        }}
        className="w-full pb-8 pt-9 lg:pt-[75px]"
      >
        <p className="text-center text-sm text-[#111928] lg:text-2xl">
          2024年Sorra年度票選大賞經已圓滿結束，
          <br className="block lg:hidden" />
          本年度我地一共收到了⋯
        </p>
        <div className="mt-6 flex justify-center gap-x-6 lg:mt-12 lg:gap-x-15">
          <div>
            <div className="flex flex-row font-rubik font-semibold text-[#F16B7C] lg:hidden">
              <AnimateTargetNumber
                target={3}
                repeat={1}
                duration={1}
                width={22}
                customHeight={32}
                fontSize={32}
              />
              <AnimateTargetNumber
                target={3}
                repeat={2}
                duration={0.7}
                width={22}
                customHeight={32}
                fontSize={32}
              />
              <AnimateTargetNumber
                target={8}
                repeat={3}
                duration={0.7}
                width={22}
                customHeight={32}
                fontSize={32}
              />
              <AnimateTargetNumber
                target={0}
                repeat={4}
                duration={0.7}
                width={22}
                customHeight={32}
                fontSize={32}
              />
              <AnimateTargetNumber
                target={7}
                repeat={5}
                duration={0.7}
                width={22}
                customHeight={32}
                fontSize={32}
              />
            </div>
            <div className="hidden flex-row font-rubik font-semibold text-[#F16B7C] lg:flex">
              <AnimateTargetNumber
                target={3}
                repeat={1}
                duration={1}
                width={48}
                customHeight={64}
                fontSize={64}
              />
              <AnimateTargetNumber
                target={3}
                repeat={2}
                duration={0.7}
                width={48}
                customHeight={64}
                fontSize={64}
              />
              <AnimateTargetNumber
                target={8}
                repeat={3}
                duration={0.7}
                width={48}
                customHeight={64}
                fontSize={64}
              />
              <AnimateTargetNumber
                target={0}
                repeat={4}
                duration={0.7}
                width={48}
                customHeight={64}
                fontSize={64}
              />
              <AnimateTargetNumber
                target={7}
                repeat={5}
                duration={0.7}
                width={48}
                customHeight={64}
                fontSize={64}
              />
            </div>
            <p className="text-center text-sm lg:text-2xl">篇產品評價</p>
          </div>
          <div>
            <div className="flex flex-row font-rubik font-semibold text-[#F16B7C] lg:hidden">
              <AnimateTargetNumber
                target={2}
                repeat={1}
                duration={1}
                width={22}
                customHeight={32}
                fontSize={32}
              />
              <AnimateTargetNumber
                target={2}
                repeat={2}
                duration={0.7}
                width={22}
                customHeight={32}
                fontSize={32}
              />
              <AnimateTargetNumber
                target={3}
                repeat={3}
                duration={0.7}
                width={22}
                customHeight={32}
                fontSize={32}
              />
              <AnimateTargetNumber
                target={2}
                repeat={4}
                duration={0.7}
                width={22}
                customHeight={32}
                fontSize={32}
              />
              <AnimateTargetNumber
                target={0}
                repeat={5}
                duration={0.7}
                width={22}
                customHeight={32}
                fontSize={32}
              />
            </div>
            <div className="hidden flex-row font-rubik font-semibold text-[#F16B7C] lg:flex">
              <AnimateTargetNumber
                target={2}
                repeat={1}
                duration={1}
                width={48}
                customHeight={64}
                fontSize={64}
              />
              <AnimateTargetNumber
                target={2}
                repeat={2}
                duration={0.7}
                width={48}
                customHeight={64}
                fontSize={64}
              />
              <AnimateTargetNumber
                target={3}
                repeat={3}
                duration={0.7}
                width={48}
                customHeight={64}
                fontSize={64}
              />
              <AnimateTargetNumber
                target={2}
                repeat={4}
                duration={0.7}
                width={48}
                customHeight={64}
                fontSize={64}
              />
              <AnimateTargetNumber
                target={0}
                repeat={5}
                duration={0.7}
                width={48}
                customHeight={64}
                fontSize={64}
              />
            </div>
            <p className="text-center text-sm lg:text-2xl">經認證票數</p>
          </div>
        </div>
        <p className="mt-6 text-center text-sm lg:mt-12 lg:text-2xl">
          第1屆的主題為「如果只能選一瓶， 你會選...」， <br />
          希望大家在10種不同皮膚問題中，選擇最能有效
          <br className="block lg:hidden" />
          改善皮膚的產品～
        </p>
        <div className="mt-6 hidden lg:mt-12 lg:block">
          <div className="flex justify-normal gap-x-3 px-[18px] lg:justify-center lg:gap-x-12">
            <div className="relative flex aspect-square h-auto w-auto flex-1 shrink-0 flex-col items-center justify-center gap-y-1 overflow-hidden rounded-[10px] border-[3px] border-sorra-pink lg:aspect-auto lg:h-[144px] lg:w-[443px] lg:flex-none">
              <div
                className="flex h-full w-full cursor-pointer flex-col items-center justify-center gap-x-0 bg-white px-0 py-0 lg:flex-row lg:justify-normal lg:gap-x-5 lg:px-8 lg:py-7"
                onClick={() => {
                  router.push('/beautyawards2024/result/ranking');
                }}
              >
                <div className="aspect-[77/67] w-[46%] lg:w-[104px]">
                  <img
                    src="/images/2024/result/mobile/rank.png"
                    className="h-full w-full object-contain"
                  />
                </div>
                <div>
                  <p className="text-center font-rubik text-base font-bold text-sorra-pink lg:text-left lg:text-[28px]">
                    功能排名
                  </p>
                  <p className="mt-0 pr-0 text-center text-xs lg:mt-2.5 lg:pr-4 lg:text-left lg:text-base">
                    以功效分類，根據會員
                    <br className="block lg:hidden" />
                    投票/評價統計得出
                  </p>
                </div>
              </div>
              <div className="absolute -bottom-[13px] -right-[10px] flex aspect-square w-[46px] items-end justify-center rounded-full bg-sorra-pink lg:-bottom-[40px] lg:-right-[40px] lg:w-[88px]" />
              <div className="absolute bottom-2 right-2 lg:bottom-2.5 lg:right-2.5">
                <div className="h-[12px] w-[14px]">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="100%"
                    height="100%"
                    viewBox="0 0 9 12"
                    fill="none"
                  >
                    <path
                      d="M1 1L6.86077 5.18627C7.41912 5.58509 7.41912 6.41491 6.86077 6.81373L1 11"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div
              className="relative flex aspect-square h-auto w-auto flex-1 shrink-0 cursor-pointer flex-col items-center justify-center gap-y-1 overflow-hidden rounded-[10px] border-[3px] border-sorra-pink lg:aspect-auto lg:h-[144px] lg:w-[443px] lg:flex-none"
              onClick={() => {
                router.push('/beautyawards2024/result/trend');
              }}
            >
              <div className="flex h-full w-full flex-col items-center justify-center gap-x-0 bg-white px-0 py-0 lg:flex-row lg:justify-normal lg:gap-x-5 lg:px-8 lg:py-7">
                <div className="aspect-[77/67] w-[46%] lg:w-[86px]">
                  <img
                    src="/images/2024/result/mobile/trend.png"
                    className="h-full w-full object-contain"
                  />
                </div>
                <div>
                  <p className="text-center font-rubik text-base font-bold text-sorra-pink lg:text-left lg:text-[28px]">
                    TOP10美妝趨勢
                  </p>
                  <p className="mt-0 pr-0 text-center text-xs lg:mt-2.5 lg:pr-4 lg:text-left lg:text-base">
                    由SORRA美編嚴選的
                    <br className="block lg:hidden" />
                    2024年十大美妝趨勢
                  </p>
                </div>
              </div>
              <div className="absolute -bottom-[13px] -right-[10px] flex aspect-square w-[46px] items-end justify-center rounded-full bg-sorra-pink lg:-bottom-[40px] lg:-right-[40px] lg:w-[88px]" />
              <div className="absolute bottom-2 right-2 lg:bottom-2.5 lg:right-2.5">
                <div className="h-[12px] w-[14px]">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="100%"
                    height="100%"
                    viewBox="0 0 9 12"
                    fill="none"
                  >
                    <path
                      d="M1 1L6.86077 5.18627C7.41912 5.58509 7.41912 6.41491 6.86077 6.81373L1 11"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p className="mt-6 text-center text-2xl font-bold lg:mt-14 lg:text-5xl">
          功能排名榜
        </p>
        <MaxWidthContainer>
          <div className="relative mt-6 h-[160px] w-full overflow-visible lg:mt-12 lg:h-[280px]">
            {Array(10)
              .fill(0)
              .map((_, i) => {
                return (
                  <div
                    key={i}
                    className={`absolute left-1/2 top-0 aspect-[145/135] w-1/3 -translate-x-1/2 lg:w-1/5`}
                  >
                    <img
                      style={{
                        transformOrigin: 'top',
                        transform:
                          'translateX(300%) translateY(-10px) scale(0.8)',
                      }}
                      className={`feature-${i} object-contain opacity-0`}
                      src={`/images/2024/result/mobile/feature_${i % 10}.png`}
                    />
                  </div>
                );
              })}
          </div>
        </MaxWidthContainer>
        <div className="mt-6 block lg:mt-12 lg:hidden">
          <div className="flex justify-normal gap-x-3 px-[18px] lg:justify-center lg:gap-x-12">
            <div className="relative flex aspect-square h-auto w-auto flex-1 shrink-0 flex-col items-center justify-center gap-y-1 overflow-hidden rounded-[10px] border-[3px] border-sorra-pink lg:aspect-auto lg:h-[144px] lg:w-[443px] lg:flex-none">
              <div
                className="flex h-full w-full cursor-pointer flex-col items-center justify-center gap-x-0 bg-white px-0 py-0 lg:flex-row lg:justify-normal lg:gap-x-5 lg:px-8 lg:py-7"
                onClick={() => {
                  router.push('/beautyawards2024/result/ranking');
                }}
              >
                <div className="aspect-[77/67] w-[46%] lg:w-[104px]">
                  <img
                    src="/images/2024/result/mobile/rank.png"
                    className="h-full w-full object-contain"
                  />
                </div>
                <div>
                  <p className="text-center font-rubik text-base font-bold text-sorra-pink lg:text-left lg:text-[28px]">
                    功能排名
                  </p>
                  <p className="mt-0 pr-0 text-center text-xs lg:mt-2.5 lg:pr-4 lg:text-left lg:text-base">
                    以功效分類，根據會員
                    <br className="block lg:hidden" />
                    投票/評價統計得出
                  </p>
                </div>
              </div>
              <div className="absolute -bottom-[13px] -right-[10px] flex aspect-square w-[46px] items-end justify-center rounded-full bg-sorra-pink lg:-bottom-[40px] lg:-right-[40px] lg:w-[88px]" />
              <div className="absolute bottom-2 right-2 lg:bottom-2.5 lg:right-2.5">
                <div className="h-[12px] w-[14px]">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="100%"
                    height="100%"
                    viewBox="0 0 9 12"
                    fill="none"
                  >
                    <path
                      d="M1 1L6.86077 5.18627C7.41912 5.58509 7.41912 6.41491 6.86077 6.81373L1 11"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div
              className="relative flex aspect-square h-auto w-auto flex-1 shrink-0 cursor-pointer flex-col items-center justify-center gap-y-1 overflow-hidden rounded-[10px] border-[3px] border-sorra-pink lg:aspect-auto lg:h-[144px] lg:w-[443px] lg:flex-none"
              onClick={() => {
                router.push('/beautyawards2024/result/trend');
              }}
            >
              <div className="flex h-full w-full flex-col items-center justify-center gap-x-0 bg-white px-0 py-0 lg:flex-row lg:justify-normal lg:gap-x-5 lg:px-8 lg:py-7">
                <div className="aspect-[77/67] w-[46%] lg:w-[86px]">
                  <img
                    src="/images/2024/result/mobile/trend.png"
                    className="h-full w-full object-contain"
                  />
                </div>
                <div>
                  <p className="text-center font-rubik text-base font-bold text-sorra-pink lg:text-left lg:text-[28px]">
                    TOP10美妝趨勢
                  </p>
                  <p className="mt-0 pr-0 text-center text-xs lg:mt-2.5 lg:pr-4 lg:text-left lg:text-base">
                    由SORRA美編嚴選的
                    <br className="block lg:hidden" />
                    2024年十大美妝趨勢
                  </p>
                </div>
              </div>
              <div className="absolute -bottom-[13px] -right-[10px] flex aspect-square w-[46px] items-end justify-center rounded-full bg-sorra-pink lg:-bottom-[40px] lg:-right-[40px] lg:w-[88px]" />
              <div className="absolute bottom-2 right-2 lg:bottom-2.5 lg:right-2.5">
                <div className="h-[12px] w-[14px]">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="100%"
                    height="100%"
                    viewBox="0 0 9 12"
                    fill="none"
                  >
                    <path
                      d="M1 1L6.86077 5.18627C7.41912 5.58509 7.41912 6.41491 6.86077 6.81373L1 11"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-10 hidden justify-center lg:mt-12 lg:flex">
          <button
            className="rounded-full bg-sorra-pink px-[46px] py-3 text-base font-medium text-white lg:py-4 lg:text-2xl"
            onClick={() => {
              router.push('/beautyawards2024/result/ranking');
            }}
          >
            查看完整排名
          </button>
        </div>
        <div className="mt-10 flex justify-center px-12">
          <div className="aspect-[283/100] w-full lg:w-[651px]">
            <img
              src="/images/2024/result/mobile/investigate.png"
              className="h-full w-full object-contain"
            />
          </div>
        </div>
        <MaxWidthContainer className="mt-[42px] flex flex-col justify-normal gap-y-[42px] lg:mt-[51px] lg:flex-row lg:justify-center">
          <div
            style={{
              boxShadow: '3px 3px 4.5px 0px rgba(0, 0, 0, 0.05)',
            }}
            className="relative mx-5 h-auto w-auto rounded-xl bg-white px-5 pb-4 pt-7 lg:h-[312px] lg:w-[578px] lg:px-[70px] lg:pt-10"
          >
            <CardTitle n={1} title="Sorra會員的平均年齡為…" />
            <div className="flex w-full justify-center">
              <img
                className="block aspect-[513/207] w-full object-contain lg:hidden lg:w-[430px]"
                src="/images/2024/result/mobile/statistic.png"
              />
              <img
                className="hidden aspect-[430/128] w-full object-contain lg:block lg:w-[430px]"
                src="/images/2024/result/mobile/statistic_desktop.png"
              />
            </div>
            <p className="mt-4 text-center text-[13px] font-normal !leading-[150%] lg:mt-6 lg:text-2xl">
              原來Sorra讀者以90後佔最多數，第2則是新世代Gen-Z！而35歲或以上則佔15%，證明愛美
              是不分年齡的～
            </p>
            <img
              src="/images/2024/middle-right.png"
              className="absolute -right-5 top-1/2 h-[70px] -translate-y-1/2 -rotate-6 lg:h-[94px] lg:-translate-y-full"
            />
          </div>
          <div
            style={{
              boxShadow: '3px 3px 4.5px 0px rgba(0, 0, 0, 0.05)',
            }}
            // className="relative mx-5 flex h-auto w-auto gap-x-9 rounded-xl bg-white px-9 pb-4 pt-7 lg:h-[312px] lg:w-[578px]"
            className="relative mx-5 flex h-auto w-auto gap-x-9 rounded-xl bg-white px-9 pb-4 pt-7 lg:h-[312px] lg:w-[578px] lg:gap-x-[55px] lg:px-[67px] lg:pt-10"
          >
            <CardTitle n={2} title="Sorra會員中，最多是…" />
            {Array(3)
              .fill(0)
              .map((_, i) => {
                return (
                  <div
                    key={i}
                    className="flex flex-1 flex-shrink-0 flex-col items-center justify-center gap-y-2.5"
                  >
                    <img
                      style={{
                        height: '33px',
                        width: i == 0 ? '38px' : '28px',
                      }}
                      className="w-[38px] object-contain"
                      src={`/images/2024/result/mobile/crown_${i}.png`}
                    />
                    <img
                      src={`/images/2024/results/${i == 0 ? '2' : i == 1 ? '11' : '4'}.png`}
                    />
                    <PercentDesc
                      percent={i == 0 ? 39 : i == 1 ? 27 : 6}
                      desc={
                        i == 0
                          ? '經典愛好者'
                          : i == 1
                            ? '混搭大師'
                            : '奢華追求者'
                      }
                    />
                  </div>
                );
              })}
          </div>
        </MaxWidthContainer>
        <MaxWidthContainer className="mt-[42px] flex flex-col justify-normal gap-y-[42px] lg:mt-[51px] lg:flex-row lg:justify-center">
          <div
            style={{
              boxShadow: '3px 3px 4.5px 0px rgba(0, 0, 0, 0.05)',
            }}
            className="relative mx-5 flex h-auto w-auto gap-x-9 rounded-xl bg-white px-9 pb-4 pt-7 lg:h-[312px] lg:w-[578px] lg:gap-x-[55px] lg:px-[67px] lg:pt-10"
          >
            <CardTitle n={3} title="最關注的3大皮膚問題" />
            {Array(3)
              .fill(0)
              .map((_, i) => {
                return (
                  <div
                    key={i}
                    className="flex flex-1 flex-shrink-0 flex-col items-center justify-center gap-y-2.5 lg:gap-y-2"
                  >
                    <img
                      style={{
                        height: '33px',
                        width: i == 0 ? '38px' : '28px',
                      }}
                      className="w-[38px] object-contain"
                      src={`/images/2024/result/mobile/crown_${i}.png`}
                    />
                    <img
                      className="aspect-[62/78] object-contain"
                      src={`/images/2024/result/mobile/${i == 0 ? 'moist' : i == 1 ? 'pores' : 'dark'}.png`}
                    />
                    <PercentDesc
                      percent={i == 0 ? 57 : i == 1 ? 45 : 38}
                      desc={i == 0 ? '補濕' : i == 1 ? '毛孔粗大' : '膚色暗沈'}
                    />
                  </div>
                );
              })}
          </div>
          <div
            style={{
              boxShadow: '3px 3px 4.5px 0px rgba(0, 0, 0, 0.05)',
            }}
            className="relative mx-5 h-auto w-auto rounded-xl bg-white px-5 pb-4 pt-7 lg:h-[312px] lg:w-[578px] lg:px-9 lg:pt-10"
          >
            <CardTitle n={4} title="最受歡迎的品牌是…" />
            <div className="flex w-full justify-center">
              <img
                className="block aspect-[204/58] w-full object-contain lg:hidden"
                src="/images/2024/result/mobile/kiehls.png"
              />
              <img
                className="hidden aspect-[185/88] w-[185px] object-contain lg:block"
                src="/images/2024/result/mobile/kiehls_desktop.png"
              />
            </div>
            <p className="mt-3 text-center font-rubik text-[13px] !leading-[150%] lg:mt-7 lg:text-2xl">
              在2024年年度票選中，超過30%的讀者都投選了Kiehl’s的產品！創立160多年來Kiehl’s以先進的技術與高濃度的天然成分，為顧客調配有效的
              護膚及護髮配方～
            </p>
          </div>
        </MaxWidthContainer>
        <MaxWidthContainer className="mt-[42px] flex flex-col justify-normal lg:mt-[51px] lg:flex-row lg:justify-center">
          <div
            style={{
              boxShadow: '3px 3px 4.5px 0px rgba(0, 0, 0, 0.05)',
            }}
            // className="relative mx-5 flex h-auto w-auto items-center gap-x-[14px] rounded-xl bg-white px-5 pb-4 pt-7 lg:h-[351px] lg:w-[632px]"
            className="relative mx-5 flex h-auto w-auto items-start gap-x-[14px] rounded-xl bg-white px-5 pb-4 pt-7 lg:h-[351px] lg:w-[632px] lg:items-center lg:px-11 lg:pt-7"
          >
            <CardTitle n={5} title="超過35%會員都有投選的產品是…" />
            <div className="w-[28%] shrink-0">
              <img
                className="aspect-[92/144] w-full object-contain"
                src="/images/2024/result/mobile/kiehls_first.png"
              />
            </div>
            <div>
              <p className="text-sm text-[#4A4A4A] lg:text-[20px]">Kiehl’S</p>
              <p className="text-[15px] font-medium text-[#111928] lg:text-2xl">
                醫學維C淡斑精華
              </p>
              <p className="mt-2.5 text-[13px] font-normal !leading-[150%] lg:mt-[18px] lg:text-2xl">
                有不少讀者都認同提亮、淡斑有感的精華！即使是敏感肌/乾肌在使用後也不會覺得乾燥，妝前使用也不會起擦膠碎～是一款綜合表現很不錯的維他命C精華！
              </p>
            </div>
          </div>
        </MaxWidthContainer>
        <div className="mt-8 flex justify-center lg:mt-12 lg:hidden">
          <button
            className="rounded-full bg-sorra-pink px-[46px] py-3 text-base font-medium text-white lg:py-4 lg:text-2xl"
            onClick={() => {
              router.push('/beautyawards2024/result/ranking');
            }}
          >
            查看完整排名
          </button>
        </div>
      </div>
    </div>
  );
};

export default BeautyAwards2024Result;

// export async function getServerSideProps(ctx) {
//   const { key } = ctx.query;
//   try {
//     const { data: campaigns } = await api.request({
//       method: 'GET',
//       url: `/api/v3/campaigns`,
//     });
//     const targetCampaign = _.find(campaigns, { name: 'BEAUTY_AWARD_2024' });
//     if (targetCampaign || key === 'F5A3302A-E6AB-44E7-ABEB-D41DECD1DCAA') {
//       return {
//         props: {},
//       };
//     } else {
//       return {
//         props: {
//           expired: true,
//         },
//       };
//     }
//   } catch (e) {
//     console.log(e);
//   }
//   return {
//     notFound: true,
//   };
// }
